import React from 'react';
import { useAppDispatch } from '../../../app/hooks';
import IDAustriaButton from './IDAustriaButton';
import { SubmitButton } from '../shared/SubmitButton';
import { useAppTranslation } from '../../../i18n';
import { changeStep } from '../../../app/slices/step.slice';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const BankAuthTypeSelection = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();

	const handleSubmit = () => {
		dispatch(changeStep('BANK_STEP'));
	};

	return (
		<div id="bank-auth-type-step" className="bank-auth-type-selection-step">
			<h1 className="bank-auth-type-header">
				<p>{t(`${TRANSLATION_PREFIX}.bank-auth-type-header`)}</p>
			</h1>
			<IDAustriaButton />
			<div className="horizontal-line-wrapper">
				<div className="horizontal-line"></div>
				<span className="horizontal-line-or">{t(`${TRANSLATION_PREFIX}.bank-auth-type-or`)}</span>
				<div className="horizontal-line"></div>
			</div>
			<SubmitButton
				disabled={false}
				submitting={false}
				text={t('button.continue-to-list-of-banks')}
				onSubmit={handleSubmit}
			/>
		</div>
	);
};

export default BankAuthTypeSelection;
